import { useState, useCallback } from "react";

export const useCollapsedState = () => {
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem("sidebarCollapsed") === "true"
  );

  const handleCollapsed = useCallback(() => {
    setCollapsed((prev) => {
      const newValue = !prev;
      localStorage.setItem("sidebarCollapsed", newValue);
      // Mapbox canvases need an explicit resize signal after the sidebar
      // width change — dispatch twice: once immediately and once after a
      // short delay to cover any residual layout reflow.
      requestAnimationFrame(() => window.dispatchEvent(new Event("resize")));
      setTimeout(() => window.dispatchEvent(new Event("resize")), 150);
      return newValue;
    });
  }, []);

  return { collapsed, handleCollapsed };
};
